import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rk-agb',
  templateUrl: './agb.component.html',
  styleUrls: ['./agb.component.css']
})
export class AgbComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
